/*
  cq-map-loader.js (round 3, A1-06): loads a map section's libraries and data after the page has painted.

  Used by sections/water-hardness-map-section.liquid, PFAS-map-section.liquid and lead-water-map-section.liquid.
  Leaflet 1.9.4 and its plugins are theme assets (same files as the npm release, fetched from cdnjs), so the map
  pages no longer depend on unpkg.com and the big data files no longer block the first paint.

  window.cqMapLoader({ root, css: [urls], js: [urls in run order], ready(), fail() }) returns { load() }.
  Loading starts on whichever comes first: the first tap, key or focus inside root, an explicit load() call
  (for example from a button handler), or idle time after the window load event. Scripts download in parallel
  and run in the listed order. ready() runs once when every file has loaded; fail() runs if a script fails.
*/
(function () {
  if (window.cqMapLoader) return;
  var files = {};

  function addCss(href) {
    if (!files[href]) {
      files[href] = new Promise(function (done) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = link.onerror = done; // a missing stylesheet must not stop the map
        document.head.appendChild(link);
      });
    }
    return files[href];
  }

  function addJs(src) {
    if (!files[src]) {
      files[src] = new Promise(function (done, failed) {
        var script = document.createElement('script');
        script.src = src;
        script.async = false; // keep run order (Leaflet before its plugins and the data)
        script.onload = done;
        script.onerror = function () {
          delete files[src];
          failed(new Error('cq-map-loader: ' + src));
        };
        document.head.appendChild(script);
      });
    }
    return files[src];
  }

  window.cqMapLoader = function (options) {
    var root = options.root || document;
    var events = ['pointerdown', 'keydown', 'focusin', 'touchstart'];
    var started = null;

    function load() {
      if (started) return started;
      events.forEach(function (name) {
        root.removeEventListener(name, load, true);
      });
      var wait = (options.css || []).map(addCss).concat((options.js || []).map(addJs));
      started = Promise.all(wait).then(
        function () {
          if (options.ready) options.ready();
        },
        function (error) {
          if (options.fail) options.fail(error);
        }
      );
      return started;
    }

    events.forEach(function (name) {
      root.addEventListener(name, load, { capture: true, passive: true });
    });

    function idle() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 2500 });
      else setTimeout(load, 300);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });

    return { load: load };
  };
})();
